import ReactDOM from 'react-dom';
import EnviziPriceEstimator from './components/EnviziPriceEstimator';
import { IntlProvider } from 'react-intl';
import normalizeWidgetInput from 'src/common/normalizeWidgetInput';
import widgetDefinition from './EnviziPriceEstimator.widget';
import { IBMLocale } from 'src/common/locale/mapValidLocale';
import { RenderFn } from 'src/types/widgets';
import 'carbon-components/css/carbon-components.min.css';

/**
 * Renders the widget.
 *
 * It renders a react application as the widget.
 *
 * @param {string} instanceId
 *   The already present HTML element ID where the react app will be rendered.
 * @param {string} langCode
 *   The language code for internationalization purposes.
 * @param {string} origin
 *   Protocol and hostname where a JSONAPI endpoint is available.
 * @param {Function} cb
 *   A callback that executes after the widget has been rendered.
 */
export type RenderFnWithOptions = (
  instanceId: string,
  formId: string,
  langCode: IBMLocale,
  options: {
    column: number;
    theme: 'light';
    singleStep: boolean;
    triggerManually: boolean;
  },
  cb: (e: HTMLElement) => void,
) => Promise<void>;

const render: RenderFn = async function (instanceId, langCode, _origin, cb) {
  const { element, locale, messages } = await normalizeWidgetInput(
    instanceId,
    langCode,
    widgetDefinition,
  );
  if (!element || !locale) {
    return;
  }
  const localeCode = element.getAttribute('data-localecode') || 'en-us';
  ReactDOM.render(
    <IntlProvider locale={locale} messages={messages} defaultLocale="en">
      <EnviziPriceEstimator
        element={element}
        langCode={localeCode}
        test={false}
        countryToTest={'us'}
      />
    </IntlProvider>,
    element,
    () => cb(element),
  );
};

export default render;
